import React, { useEffect, useMemo } from 'react';
import * as THREE from 'three';
import { fenceTraces } from '../lib/camera-framing';

/**
 * The ground trace of each fence as one set of thin line segments, so a section is visible from above (Top view)
 * where the vertical plane itself is edge-on. `groundY(lon, lat)` (draped scene) lifts it onto the terrain.
 * `fences` and `groundY` must be referentially stable.
 */
export default function FenceTraces({ fences, origin, groundY = null, color = '#ffd400' }) {
  const geometry = useMemo(() => {
    const pos = fenceTraces(fences, origin, groundY ? (lon, lat) => groundY(lon, lat) + 0.3 : null);
    if (!pos.length) return null;
    if (!groundY) for (let i = 1; i < pos.length; i += 3) pos[i] = 0.3;
    const g = new THREE.BufferGeometry();
    g.setAttribute('position', new THREE.BufferAttribute(pos, 3));
    return g;
  }, [fences, origin, groundY]);
  useEffect(() => () => geometry?.dispose(), [geometry]);
  if (!geometry) return null;
  return (
    <lineSegments geometry={geometry} renderOrder={5} name="fence-traces">
      <lineBasicMaterial color={color} depthTest={false} transparent />
    </lineSegments>
  );
}
